import Swal from 'sweetalert2';

export default Swal.mixin({ confirmButtonText: '確定', cancelButtonText: '取消', denyButtonText: '否' });
